module.exports = __webpack_public_path__ + "static/app-store-badge-fr-2cfdd0a74cd257a00a1821b968acfa92.svg";